import { useEffect, useState } from 'react';

export const useDeliveryOptionsMetrics = () => {
  const [hasInitialGeoData, setHasInitialGeoData] = useState(false);

  const [entry, setEntry] = useState({
    PickupInStore: 0,
    HomeDelivery: 0,
    StockInStore: 0,
  });
  const [counts, setCounts] = useState({
    PickupInStore: null,
    HomeDelivery: null,
    StockInStore: null,
  });
  const [entryGeo, setEntryGeo] = useState({
    parentStateName: null,
    comunaName: null,
    parentCountyName: null,
  });
  const [changedGeo, setChangedGeo] = useState({
    parentStateName: 'x',
    comunaName: 'x',
    parentCountyName: 'x',
  });

  const handleSetEntry = (entryType) => {
    if (entryType) {
      setEntry((prevEntry) => ({
        ...prevEntry,
        [entryType]: 1,
      }));
    }
  };

  const handleSetCounts = (entryType, quantity) => {
    if (quantity > 0) {
      setCounts((prevCounts) => ({
        ...prevCounts,
        [entryType]: quantity,
      }));
    } else {
      setCounts((prevCounts) => ({
        ...prevCounts,
        [entryType]: 'No Disponible',
      }));
    }
  };
  const handleSetEntryGeoData = (geoData, regionCode) => {
    const { parentStateName, comunaName, parentCountyName } = geoData;
    if (parentStateName === '' || comunaName === '' || (regionCode !== 'cl' && parentCountyName === '')) {
      return;
    }
    if (!hasInitialGeoData) {
      setEntryGeo({
        parentStateName,
        comunaName,
        parentCountyName: regionCode !== 'cl' ? parentCountyName : 'x',
      });
      setHasInitialGeoData(true);
    }
  };
  const handleChangedGeoData = (geoData, regionCode) => {
    if (hasInitialGeoData) {
      const newGeoData = {
        parentStateName: geoData.parentStateName || 'x',
        comunaName: geoData.comunaName || geoData.name || 'x',
        parentCountyName: regionCode !== 'cl' ? geoData.parentCountyName : 'x',
      };
      const comunaChanged = entryGeo.comunaName !== newGeoData.comunaName;
      if (comunaChanged) {
        setChangedGeo(newGeoData);
      }
    }
  };

  const clearMetricsData = ({ selectedType, isCambiar }) => {
    if (!isCambiar) {
      setEntry({
        PickupInStore: selectedType === 'PickupInStore' ? 1 : 0,
        HomeDelivery: selectedType === 'HomeDelivery' ? 1 : 0,
        StockInStore: selectedType === 'StockInStore' ? 1 : 0,
      });
    }
    setCounts({
      PickupInStore: null,
      HomeDelivery: null,
      StockInStore: null,
    });
  };

  const resetAllMetricsData = () => {
    setEntry({
      PickupInStore: 0,
      HomeDelivery: 0,
      StockInStore: 0,
    });
    setCounts({
      PickupInStore: null,
      HomeDelivery: null,
      StockInStore: null,
    });
    setEntryGeo({
      parentStateName: 'x',
      comunaName: 'x',
      parentCountyName: 'x',
    });
    setChangedGeo({
      parentStateName: 'x',
      comunaName: 'x',
      parentCountyName: 'x',
    });
    setHasInitialGeoData(false);
  };

  useEffect(() => {
    if (
      counts.HomeDelivery !== null &&
      counts.PickupInStore !== null &&
      counts.StockInStore !== null &&
      entryGeo.parentStateName !== null &&
      entryGeo.comunaName !== null &&
      entryGeo.parentCountyName !== null
    ) {
      const doClick = `${entry.HomeDelivery}-${entry.PickupInStore}-${entry.StockInStore}|${counts.HomeDelivery}-${counts.PickupInStore}-${counts.StockInStore}|${entryGeo.parentStateName}-${entryGeo.comunaName}-${entryGeo.parentCountyName}|${changedGeo.parentStateName}-${changedGeo.comunaName}-${changedGeo.parentCountyName}`;
      const eventToDigitalData = new CustomEvent('DeliveryOptionsMetrics', {
        bubbles: true,
        detail: {
          payload: {
            doClick,
          },
        },
      });
      window.dispatchEvent(eventToDigitalData);
    }
  }, [
    counts.HomeDelivery,
    counts.PickupInStore,
    counts.StockInStore,
    changedGeo.comunaName,
    entry.HomeDelivery,
    entry.PickupInStore,
    entry.StockInStore,
  ]);

  return {
    handleSetEntry,
    handleSetCounts,
    handleSetEntryGeoData,
    handleChangedGeoData,
    clearMetricsData,
    resetAllMetricsData,
  };
};
